import { elementScrollIntoView } from "seamless-scroll-polyfill";
import { lp } from "./logPrefix";
import { PostMessageCVPScrollHost, PostMessageTypes } from "./PostMessageTypes";
import { routerStore } from "./WSRouter";

export const scrollIntoView = (target: HTMLElement) => {
  if (window.cvpEmbedType === "iframe" && !window.cvpSandboxType) {
    function cumulativeOffset(element: HTMLElement) {
      let top = 0;
      do {
        top += element.offsetTop || 0;
        element = element.offsetParent as HTMLElement;
      } while (element);

      return top;
    }

    const top = cumulativeOffset(target);

    const msg: PostMessageCVPScrollHost = {
      type: PostMessageTypes.CVPScrollHost,
      top,
      height: target.getBoundingClientRect().height,
    };

    window.top.postMessage(msg, new URL(routerStore.hostUrl).origin);
    console.log(lp("window.top.postMessage"), msg);

    return;
  }

  target.classList.add("cvp-scrolling-element-into-view");

  /*
  // account for fixed top bars when programatically scrolling elements into view like this:
  // (add this css rule to settings.css)
  .cvp-scrolling-element-into-view {
    scroll-margin-top: 96px;
  }
  */

  elementScrollIntoView(target, {
    behavior: "auto",
    block: "start",
    inline: "start",
  });
};
